import $ from "jquery";
import Base from "@patternslib/patternslib/src/core/base";
import _ from "underscore";
import utils from "@plone/mockup/src/core/utils";
import 'jquery-ui/ui/widgets/draggable';
import "./focalpoint.scss";


export default Base.extend({
  name: 'focalpoint',
  trigger: '.pat-focalpoint',
  parser: 'mockup',

  defaults: {
  },

  load_icons: async function () {
    return {
        edit: await utils.resolveIcon("pencil-square"),
        remove: await utils.resolveIcon("trash")
    };
  },

  setBackgroundImage: function(){
    let self = this;
    let url = self.picker.attr('src');
    self.background.css('background', "url("+ url +") no-repeat center top");
    self.background.css('background-size', 'cover');
  },

  init: async function() {
    let self = this;
    // let icons = await this.load_icons();
    self.picker = $('#'+self.options.id+'-picker img', self.$el); // image to click
    self.point = $('#'+self.options.id+'-point', self.$el); // cyan focal dot
    self.background = $('#'+self.options.id+'-background-container', self.$el); // where background element is applied
    self.controls = $("div.controls .control", self.$el); // control to toggle between desktop, mobile and tablet
    self.viewport = $('div.viewport', self.$el); // viewport to switch between screen sizes
    self.results = $('div.controls span.results', self.$el);
    self.setBackgroundImage();
    self.setEventListeners();
    self.x = $('input[name="'+self.options.focal_pos_x+'"]', self.$el).val(); // x background position
    self.y = $('input[name="'+self.options.focal_pos_y+'"]', self.$el).val(); // y background position
    self.background.css('background-position', self.x + "% " + self.y + "%");
    self.point.css({
      top: self.y + "%",
      left: self.x + "%",
    });
    self.updateResults();
  },

  setEventListeners: function() {
    let self = this;
    self.point.draggable({
      cursor: "move",
      drag: self.dragging.bind(self),
      containment: '#'+self.options.id+'-picker'
    });
    // self.controls.on('click', self.changeViewport);
  },

  dragging: function(e) {
    let self = this;
    let diffy = self.picker.height() - self.point.height();
    let diffx = self.picker.width() - self.point.width();

    self.x = Math.round((e.target.offsetLeft / diffx) * 100);
    self.y = Math.round((e.target.offsetTop / diffy) * 100);

    self.background.css('background-position', self.x + "% " + self.y + "%");
    self.updateResults();
  },

  changeViewport : function(e) {
    let self = this;
    var type = $(this).attr('id');
    self.viewport
      .removeClass('desktop')
      .removeClass('mobile')
      .removeClass('tablet')
      .addClass(type);
    self.controls.removeClass('active');
    $(this).addClass('active');
  },

  updateResults : function() {
    let self = this;
    self.results.text('Position: ' + self.x + '% ' + self.y + "%");
    $('input[name="'+self.options.focal_pos_x+'"]', self.$el).val(self.x);
    $('input[name="'+self.options.focal_pos_y+'"]', self.$el).val(self.y);
  }
});